<template>
    <div>
        <main-layout :ShowBottomBar="false" :NeedLogin="true" :ResizeCallback="Resize">
            <div class="definition">
                <el-row>
                    <el-col :span="24">
                        <div class="title">
                          GP Pdf
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table :data="tableData" style="width: 95%;font-size:small" v-bind:style="{height: this.TableHeight + 'px'}">
                            <el-table-column prop="Name" label="Name" width="350">
                            </el-table-column>
                            <el-table-column label="Download file">
                                <template scope="scope">
                                    <el-button type="text" size="small" @click="GetFile()">Download</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </div>
        </main-layout>

    </div>
</template>
<style scoped>
.definition {
  font-family: "HelveticaNeue-Medium";
  padding-left: 28px;
}
</style>
<script>
import * as api from "../api";
import * as d3 from "d3-collection";
import * as lib from "../lib/lib.js";
import MainLayout from "../components/MainLayout.vue";

export default {
  data() {
    return {
      TableHeight: window.innerHeight - 244,
      dialogFormVisible: false
    };
  },
  computed: {
    tableData: function() {
      return [
        {
          Name: this.$store.state.route.query.name,
          Description: "This is the description"
        }
      ];
    }
  },
  created: function() {},
  methods: {
    Resize: function() {
      let height = window.innerHeight - 145 - 137 - 20;
      this.TableHeight = height <= 250 ? 250 : height;
    },
    GetFile: function() {
      api.getFile(this.$store.state.route.query.name).then(
        response => {
          lib.showFile(this.$store.state.route.query.name, response.body);
        },
        response => {
          this.loading = false;
          this.$notify.error({
            title: "Error",
            message: "Cannot find the requested file"
          });
          console.log(response);
        }
      );
    }
  },
  mounted: function() {},
  components: {
    MainLayout
  }
};
</script>




// WEBPACK FOOTER //
// GPFile.vue?0e992bc2